import { CheckIcon, LinkIcon, UploadIcon, XIcon } from "@primer/octicons-react";
import { Box, Link, TextInput } from "@primer/react";

import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { foThucDonApi } from "../../../../api/foThucDonApi";
import { uploadApi } from "../../../../api/uploadApi";
import { appInfo } from "../../../../AppInfo";
import { AnimationPopup } from "../../../../components/modal";
import {
  PopUpForm,
  PopUpFormActions,
} from "../../../../components/pop-up-form/PopUpForm";
import Button from "../../../../components/ui/button";
import DataTable from "../../../../components/ui/data-table";
import { useCommonContext } from "../../../../contexts/common";
import { NotifyHelper } from "../../../../helpers/toast";
import { RootState } from "../../../../state/reducers";
import styles from "./ThucDonImport.module.css";
import SelectBoxTruongMultiple from "../../../../components/selectbox-truong-multiple";

interface IThucDonImportModalProps {
  onClose: () => void;
  animationOf: string;
  dm_truong_id: number;
}

const ThucDonImport = (props: IThucDonImportModalProps) => {
  const { translate } = useCommonContext();
  const { animationOf, onClose, dm_truong_id } = props;
  const { dm_truong_selected_id, nam_hoc } = useSelector(
    (x: RootState) => x.common
  );
  const [uploadedFileName, setUploadedFileName] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const componentDidMount = useRef<boolean>(false);
  const [dataSouce, setDataSouce] = useState<any[]>([]);
  const [dataSouceValidated, setDataSouceValidated] = useState<any[]>([]);
  const [schoolIdSelecteds, setSchoolIdSelecteds] = useState<number[]>([]);

  const notValidCount = useMemo<number>(() => {
    return dataSouceValidated.filter((x) => x["Thông tin lỗi"] !== "").length;
  }, [dataSouceValidated]);
  const handleSelectFile = () => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute(
      "accept",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    );
    input.click();
    input.onchange = async () => {
      var file = input && input.files ? input.files[0] : null;
      if (file) {
        const res = await uploadApi.uploadExcel(file);
        if (res.is_success) {
          setUploadedFileName(res.data.fileNameId);
        } else {
          NotifyHelper.Error(res.message ?? "Error");
        }
      }
    };
    input.remove();
  };
  useEffect(() => {
    componentDidMount.current = true;
    if (uploadedFileName !== "") {
      setIsLoading(true);
      handleReadUploadedFile();
      setIsLoading(false);
    }
  }, [uploadedFileName]);

  const handleReadUploadedFile = async () => {
    setIsLoading(true);
    const res = await uploadApi.readExcel({
      fileName: uploadedFileName,
      sheetIndex: 0,
    });

    if (!componentDidMount.current) return;
    setIsLoading(false);

    if (res.is_success) {
      setDataSouce(res.data);
    }
    await handleValidateImportFile();
  };
  const handleValidateImportFile = async () => {
    setIsLoading(true);
    const datasend = {
      fileName: uploadedFileName,
      sheetIndex: 0,
    };
    const res = await foThucDonApi.validate_import(datasend, dm_truong_id);
    if (!componentDidMount.current) return;
    if (res.is_success) {
      setDataSouceValidated(res.data);
    }
    setIsLoading(false);
  };
  const hanldeImport = async () => {
    if (!schoolIdSelecteds || schoolIdSelecteds.length === 0) {
      NotifyHelper.Error("Vui lòng Chọn cấp học");
      return;
    }
  
    setIsLoading(true);
    const datasend = {
      fileName: uploadedFileName,
      sheetIndex: 0,
    };
  
    try {
      for (const schoolId of schoolIdSelecteds) {
        const res = await foThucDonApi.import(datasend, schoolId);
        
        if (!componentDidMount.current) return;
  
        if (res.is_success) {
          //NotifyHelper.Success(`Import thành công cho trường ${schoolId}`);
        } else {
          //NotifyHelper.Error(`Lỗi import cho trường ${schoolId}: ${res.message ?? "Error"}`);
        }
      }
      
      NotifyHelper.Success("Hoàn thành import cho tất cả trường đã chọn!");
      onClose();
    } catch (error) {
      NotifyHelper.Error("Có lỗi xảy ra trong quá trình import");
    } finally {
      setIsLoading(false);
    }
  };
  const columns = useMemo(() => {
    if (!dataSouceValidated || dataSouceValidated.length === 0) return [];
    const keys = Object.keys(dataSouceValidated[0]).filter(
      (key) => key !== "0" && key !== "ID"
    );

    return [
      { dataField: "0", caption: "Bữa ăn" },
      ...keys.map((key) => ({
        dataField: key,
        caption: key,
      })),
    ];
  }, [dataSouceValidated]);
  return (
    <>
      <AnimationPopup
        animationOf={animationOf}
        width={"80%"}
        title="Import thực đơn"
        onClose={onClose}
      >
        <Box
          sx={{
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            maxHeight: "85vh",
          }}
        >
          {" "}
          <Box
            sx={{
              display: "flex",
            }}
          >
            <Box></Box>
            <div className={styles.actions}>
            <Box className={styles.action_item} sx={{ flex: 1 }}>
                <SelectBoxTruongMultiple
                  maxWidth={230}
                  isShowClearBtn
                  selectedValue={schoolIdSelecteds}
                  onSelectionChanged={(ids) => {
                    setSchoolIdSelecteds(ids); 
                  }}
                />
              </Box>
              <div className={styles.action_item}>
                <Button
                  leadingVisual={UploadIcon}
                  text="Upload file"
                  onClick={handleSelectFile}
                  size="medium"
                />
              </div>
              {uploadedFileName && (
                <TextInput
                  sx={{ ml: 2, width: 400 }}
                  value={uploadedFileName}
                  readOnly
                />
              )}
             
              <div className={styles.action_item}>
                <Link
                  href={`${appInfo.baseApiURL.replace(
                    "/api",
                    ""
                  )}/TEMPLATE/IMPORT_THUCDON.xlsx`}
                  target="_blank"
                >
                  <Button
                    sx={{ color: "blue" }}
                    text={`${translate(`Tải mẫu import thực đơn tại đây`)}`}
                    variant="invisible"
                    leadingVisual={LinkIcon}
                  />
                </Link>
              </div>
            </div>
          </Box>
          <Box>
            <DataTable
              data={dataSouceValidated}
              isLoading={isLoading}
              paging={{ enable: true }}
              columns={columns}
              height={`${window.innerHeight - 340}px`}
            />
          </Box>
          <PopUpFormActions>
            <Button
              leadingVisual={XIcon}
              text="Base.Label.Close"
              onClick={onClose}
            />
            <Button
              leadingVisual={CheckIcon}
              variant="primary"
              isLoading={isLoading}
              text={"ThoiKhoaBieuImport.Label.Save"}
              disabled={notValidCount > 0}
              onClick={hanldeImport}
            ></Button>
          </PopUpFormActions>
        </Box>
      </AnimationPopup>
    </>
  );
};

export default ThucDonImport;
